import { Box, Toolbar, Typography } from '@mui/material'
import React, { createContext, Dispatch, SetStateAction, useState } from 'react'
import type { RouteObject } from 'react-router-dom'
import { Outlet } from 'react-router-dom'
import { MainView } from '~/src/components/molecules'
import { Sidebar } from '~/src/components/organisms'
import { CustomerDetail } from '~/src/components/pages/CustomerDetail'
import { ContactOrderCreate } from '~/src/components/pages/Order/ContactOrder/ContactOrderCreate/ContactOrderCreate'
import { ContactOrderDetail } from '~/src/components/pages/Order/ContactOrder/ContactOrderDetail/ContactOrderDetail'
import { ContainerOrderDetail } from '~/src/components/pages/Order/ContainerOrder/ContainerOrderDetail/ContainerOrderDetail'
import { SettingFreightDetail } from '~/src/components/pages/SettingFreightDetail/SettingFreightDetail'
import { SettingsListOfFreight } from '~/src/components/pages/SettingsListOfFreight'
import { SpecialOffer } from '~/src/components/pages/SpecialOffer/SpecialOffer'
import { useDrawer } from '~/src/hooks'
import {
  AddMemberSupportHistory,
  AddUser,
  ContactOrderList,
  ContainerOrderInstruction,
  ContainerOrderList,
  CurrencySetting,
  Dashboard,
  LanguageSetting,
  ListItem,
  ListMember,
  Login,
  MemberSupportHistory,
  MyFavoritesList,
  NotificationCreate,
  NotificationDetail,
  NotificationList,
  OrderProformaInvoiceDetail,
  OrderStatementOfAccountCreate,
  OrderStatementOfAccountDetail,
  OrderStatementOfAccountList,
  ProformaInvoiceList,
  Top,
  UserList,
  WishList,
} from './components/pages'
import { QuotationDetail } from './components/pages/Quotation/QuotationDetail/QuotationDetail'

type TCountContext = {
  count?: number
  setCount?: Dispatch<SetStateAction<number>>
}

export const CountContext = createContext<TCountContext>({
  count: 0,
  setCount: () => {},
})

const MemoizedMainView = React.memo(MainView)
const Layout = () => {
  const { isDrawerOpen } = useDrawer()
  const [count, setCount] = useState(0)

  return (
    <>
    <Box sx={{ display: 'flex' }}>
      <CountContext.Provider value={{ count, setCount }}>
        <Sidebar open={isDrawerOpen} />
        <MemoizedMainView open={isDrawerOpen}>
          <Toolbar sx={{ height: '65px' }} />
          <Box paddingTop={2.5} paddingLeft={2.5} paddingRight={2.5}>
            <Outlet />
          </Box>
        </MemoizedMainView>
      </CountContext.Provider>
    </Box>
    </>
  )
}

/**
 * routes
 * @params RouteObject[]
 */
export const routes: RouteObject[] = [
  {
    path: '/admin/login',
    element: <Login />,
  },
  {
    path: '/',
    index: true,
    element: <Top />,
  },
  {
    path: '/admin',
    element: <Layout />,
    children: [
      { path: '/admin', element: <Dashboard /> },
      { path: '/admin/settings/general', element: <LanguageSetting /> },
      { path: '/admin/order/statement-of-account/list', element: <OrderStatementOfAccountList /> },
      {
        path: '/admin/order/statement-of-account/detail',
        element: <OrderStatementOfAccountDetail />,
      },
      { path: '/admin/order/statement-of-account/add', element: <OrderStatementOfAccountCreate /> },
      {
        path: '/admin/member/support-history/:user',
        element: <MemberSupportHistory />,
      },

      {
        path: '/admin/order/proforma-invoice/list',
        element: <ProformaInvoiceList />,
      },
      {
        path: '/admin/order/proforma-invoice/detail/:id',
        element: <OrderProformaInvoiceDetail />,
      },
      {
        path: '/admin/member/list',
        element: <ListMember />,
      },
      {
        path: '/admin/order/favorites/list',
        element: <MyFavoritesList />,
      },
      {
        path: '/admin/settings/freight/list',
        element: <SettingsListOfFreight />,
      },
      {
        path: '/admin/items/list',
        element: <ListItem />,
      },
      {
        path: '/admin/member/support-history/add/:userId',
        element: <AddMemberSupportHistory />,
      },
      {
        path: '/admin/order/contact-order/detail/:id',
        element: <ContactOrderDetail />,
      },
      {
        path: '/admin/settings/freight/detail/:id',
        element: <SettingFreightDetail />,
      },
      {
        path: '/admin/user/add',
        element: <AddUser />,
      },
      {
        path: '/admin/user/list',
        element: <UserList />,
      },
      {
        path: '/admin/member/detail/:userId',
        element: <CustomerDetail />,
      },
      {
        path: '/admin/member/quotation/:userId',
        element: <QuotationDetail />, 
      },
      {
        path: '/admin/order/container-order/list',
        element: <ContainerOrderList />,
      },
      {
        path: '/admin/order/container-order/detail/:containerID',
        element: <ContainerOrderDetail />,
      },
      {
        path: '/admin/order/container-order/production-instruction/:containerId',
        element: <ContainerOrderInstruction />,
      },
      {
        path: '/admin/order/contact-order/list',
        element: <ContactOrderList />,
      },
      {
        path: '/admin/order/contact-order/add',
        element: <ContactOrderCreate />,
      },
      {
        path: '/admin/wish-list/list',
        element: <WishList />,
      },
      {
        path: '/admin/special-offer',
        element: <SpecialOffer />,
      },
      {
        path: '/admin/settings/currency',
        element: <CurrencySetting />,
      },
      {
        element: <NotificationList />,
        children: [{ path: '/admin/news/list', element: <NotificationList /> }],
      },
      {
        element: <NotificationDetail />,
        children: [{ path: '/admin/news/edit', element: <NotificationDetail /> }],
      },
      {
        element: <NotificationCreate />,
        children: [{ path: '/admin/news/add', element: <NotificationCreate /> }],
      },
    ],
  },
]
